import { createAction, props } from '@ngrx/store';

export const selectCountry = createAction('[Countries] Select Country', props<{ countryAlpha2Code: string }>());
